import React, { useState, useRef, useEffect, useCallback, useContext, useMemo } from 'react'
import styled from 'styled-components'
import { useAuthState } from 'src/providers/AuthProviders'
import { useParams } from 'react-router-dom'
import { useConversation } from 'src/pages/main/dmTalk/hooks/useConversation'
import BackGroundDefault from 'src/assets/img/common/bg_common.jpg'
import FloatBackButton from 'src/assets/img/common/float_back_btn.png'
import ArrowExpand from 'src/assets/img/realtalk/arrow_expand.png'
import ContainerIcon from 'src/assets/img/realtalk/container.png'
import RoundedIcon from 'src/assets/img/realtalk/rounded.svg'
import { ItemChatClient } from './components/ItemChatClient'
import { MainLayout } from 'src/components/layouts/MainLayout'
import { MYPAGE_CHARACTER_IMAGES } from 'src/constants/characters'
import TipsModal from 'src/components/common/TipsModal'
import MultiLoveEffectModal from 'src/components/Effect/MultiLoveEffectModal'
import { useLoadingMore } from 'src/services/hooks/useLoadingMore'
import { getConversationItem } from 'src/services/get/getChat'
import { InputStoryTalk } from 'src/components/message/ChatBox/InputStoryTalk'
import { ItemChat } from 'src/components/message/ChatBox/Item'
import { HistoryRouteContext } from 'src/routes'
import { SettingLvCharacter } from 'src/components/common/SettingLvCharacter'
import { useDispatch } from 'react-redux'
import { resetLayout, setDisplayFooter, setDisplayHeader } from 'src/redux/layout/setDisplayLayout'
import { MAIN_PATHS } from 'src/routes/main'
import LoadingIcon from 'src/components/layouts/LoadingIcon'
import NoContent from 'src/components/layouts/NoContent'
import { Header } from 'src/components/layouts/Header'
import { ModalGift } from 'src/components/common/ModalGift'

const StoryTalkDetail = () => {
  const { redirectTo } = useContext(HistoryRouteContext)
  const [sizeInput, setSizeInput] = useState(0)
  const { user } = useAuthState()
  const roomChatRef = useRef()
  const lastScrollHeight = useRef(0)
  const {
    data: conversationData,
    isFetching,
    fetchNextPage,
    hasNextPage,
    refetch,
    addNewMessageToCache,
    updateMessageToCache,
    isFetched
  } = useConversation()
  const { characterId } = useParams()
  const [character, setCharacter] = useState({})
  const [loveLvSettings, setLoveLvSettings] = useState({})
  const [isMultiLoveModalOpen, setIsMultiLoveModalOpen] = useState(false)
  const [multiLevel, setMultiLevel] = useState({})
  const [backgroundSetting, setBackgroundSetting] = useState({})
  const [present, setPresent] = useState(null)
  const [files, setFiles] = useState('')
  const [fileVideo, setFileVideo] = useState([])
  const [messages, setMessages] = useState([])
  const [scroll, setScroll] = useState(true)
  const [isOpenGift, setIsOpenGift] = useState(false)
  const [conversationId, setConversationId] = useState()
  const [isDuplicate, setIsDuplicate] = useState(true)
  const [previousTestId, setPreviousTestId] = useState(null)
  const [expandTalk, setExpandTalk] = useState(false)
  const [bgImage, setBgImage] = useState('')
  const [isBgImageSet, setIsBgImageSet] = useState(false)
  const [channelInfo, setChannelInfo] = useState()
  const [hasReadOnce, setHasReadOnce] = useState(false)

  const isNoContent = useMemo(
    () =>
      isFetched &&
      !conversationData?.pages?.find((page) => page?.first_page)?.character?.allow_story_talk,
    [conversationData, isFetched]
  )

  const scrollToLast = () => {
    roomChatRef.current?.scrollTo({
      top: roomChatRef.current?.scrollHeight - lastScrollHeight.current
    })
    lastScrollHeight.current = 0
    if (document.querySelector('#start')) {
      setIsDuplicate(false)
    }
  }

  useEffect(() => {
    if (!conversationData) return

    setMessages(conversationData.pages.map((page) => page.messages).flat())
    const firstPage = conversationData.pages.find((page) => page.first_page)

    if (firstPage) {
      setCharacter(firstPage.character)
      if (!isBgImageSet) {
        setBgImage(firstPage.last_character_background_image_url)
        setIsBgImageSet(true)
      }
      setConversationId(firstPage.conversation_id)
      setLoveLvSettings(firstPage.character_setting_level)
    }

    if (conversationData.pages && conversationData.pages[0]) {
      setChannelInfo(conversationData.pages[0])
    }
  }, [conversationData])

  useEffect(() => {
    if (conversationData) {
      refetch()
    }
  }, [])

  const changeBgImage = useCallback(
    (msg) => {
      if (!msg || !msg.is_heart_consumption || !msg.character_background_image_url) return
      setBgImage(msg.character_background_image_url)
    },
    [setBgImage]
  )

  useLoadingMore({
    selector: '#start',
    skip: !hasNextPage,
    onLoadMore: () => {
      if (isDuplicate) return
      setIsDuplicate(true)
      setTimeout(() => {
        fetchNextPage()
        lastScrollHeight.current = roomChatRef.current?.scrollHeight + 100 ?? 0
      })
    }
  })

  useEffect(() => {
    if (scroll) {
      scrollToLast()
    } else {
      setScroll(true)
    }
  }, [messages])

  const closeMultiLoveModal = useCallback(() => {
    setIsMultiLoveModalOpen(false)
    refetch()
  }, [setIsMultiLoveModalOpen, refetch])

  const handleOpenGift = async (type, msg) => {
    const giftId = type === 'character_cloth' ? msg.character_cloth_id : msg.setting_item_id
    const giftAmount = type === 'character_cloth' ? msg.number_of_avatar : msg.setting_item_amount
    if (
      (type === 'character_cloth' && !msg.is_received_cloth) ||
      (type === 'setting_item' && !msg.is_received_present)
    ) {
      const res = await getConversationItem(msg.character_chat_id, type, giftId, giftAmount)
      if (res) {
        if (!res.items) return
        setPresent(res.items)
        setIsOpenGift(true)
        if (type === 'character_cloth') {
          msg.is_received_cloth = true
        } else if (type === 'setting_item') {
          msg.is_received_present = true
        }
      } else {
        console.log('プレゼントは受け取り済みです')
      }
    }
  }

  const handleUpdateMessage = (msg) => {
    const copyMessages = [...messages]
    const index = copyMessages.findIndex(
      (message) => msg.character_chat_id === message.character_chat_id
    )
    if (index >= 0) {
      copyMessages[index] = msg
      setMessages(copyMessages)
      updateMessageToCache(msg)
      changeBgImage(msg)
    }
  }

  useEffect(() => {
    setBackgroundSetting(MYPAGE_CHARACTER_IMAGES[characterId])
  }, [characterId])

  const isMessageValidForCache = (msg, idCurrent) => {
    return msg.description || msg.attachment_url || (msg.item && idCurrent !== previousTestId)
  }

  const handleNewMessages = (msg, checkStatus) => {
    if (!msg) return
    changeBgImage(msg)

    const idCurrent = msg?.item?.item_id
    setMessages((prevMessages) => [...prevMessages, msg])

    if (isMessageValidForCache(msg, idCurrent)) {
      addNewMessageToCache(msg)
    }

    if (checkStatus === 'messageItem') {
      setPreviousTestId(idCurrent)
    }
  }

  const dispatch = useDispatch()

  return (
    <MainLayout showFooter={false} classNameHeader="">
      {isNoContent ? (
        <div className="h-full flex items-center">
          <NoContent
            isModal
            message={'直前のページに戻ります。\nナビゲーターにお知らせください'}
            redirectUrl={MAIN_PATHS.MessagePage}
          />
        </div>
      ) : (
        <>
          <MultiLoveEffectModal
            character={character}
            isMultiLoveModalOpen={isMultiLoveModalOpen}
            multiLevel={multiLevel}
            onClose={closeMultiLoveModal}
          />
          <Container
            chatBgImage={
              conversationData?.background_type === 1 ? backgroundSetting?.room : BackGroundDefault
            }
          >
            <div className="absolute z-[100] h-[100dvh] w-full">
              <Header className="" />
              <button
                className="absolute z-[100] left-[5px] top-[3.25rem]"
                onClick={() => {
                  dispatch(resetLayout())
                  redirectTo(MAIN_PATHS.MessagePage)
                }}
              >
                <img src={FloatBackButton} alt="" className="w-[4.75rem]" />
              </button>

              <SettingLvCharacter
                loveLvSettings={loveLvSettings}
                character={character}
                isMultiLoveModalOpen={isMultiLoveModalOpen}
                multiLevel={multiLevel}
                onClose={closeMultiLoveModal}
              />
              <div
                className="w-10 h-10 flex items-center"
                style={{
                  backgroundImage: `url(${RoundedIcon})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'contain'
                }}
              >
                <img
                  className={`${
                    expandTalk ? '' : 'rotate-180'
                  } absolute w-4 top-[7px] left-[18px] transition-transform duration-500`}
                  src={ArrowExpand}
                  alt=""
                />
                <img
                  className={`${
                    expandTalk ? 'rotate-180' : ''
                  } absolute w-4 bottom-2 left-1.5 transition-transform duration-500`}
                  src={ArrowExpand}
                  alt=""
                />
                <img
                  className={`${expandTalk ? 'hidden' : 'block'} absolute top-1 left-1 !w-8`}
                  src={ContainerIcon}
                  alt=""
                />
                <button
                  className="absolute z-[100] top-[90px] right-2"
                  onClick={() => {
                    dispatch(setDisplayHeader())
                    dispatch(setDisplayFooter())
                    setExpandTalk((pre) => !pre)
                  }}
                >
                  <div
                    className="relative w-10 h-10 flex items-center"
                    style={{
                      backgroundImage: `url(${RoundedIcon})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'contain'
                    }}
                  >
                    <img
                      className={`${
                        expandTalk ? '' : 'rotate-180'
                      } absolute w-4 top-[0.4375rem] left-[1.125rem] transition-transform duration-500`}
                      src={ArrowExpand}
                      alt=""
                    />
                    <img
                      className={`${
                        expandTalk ? 'rotate-180' : ''
                      } absolute w-4 bottom-2 left-1.5 transition-transform duration-500`}
                      src={ArrowExpand}
                      alt=""
                    />
                    <img
                      className={`${
                        expandTalk ? 'hidden' : 'block'
                      } absolute w-[2.125rem] left-[3px]`}
                      src={ContainerIcon}
                      alt=""
                    />
                  </div>
                </button>
                <WrapperChatBox sizeInput={sizeInput}>
                  <div className="fixed z-10 top-0 img-bg-realtalk">
                    <img
                      src={bgImage || BackGroundDefault}
                      alt=""
                      className="w-full h-screen animation-expand object-cover"
                    />
                  </div>
                </WrapperChatBox>
                <div className="fixed bottom-0 mx-auto z-10 w-[100dvw] sm:w-desktop-width">
                  <div
                    ref={roomChatRef}
                    className={`${
                      !expandTalk ? 'h-[40dvh]' : 'h-[0px]'
                    } z-20 animation-expand w-full overflow-auto bg-white/80 hidden-scroll`}
                  >
                    {isFetching ? <LoadingIcon /> : <div id="start" />}
                    {messages.map((message, i) => (
                      <div key={i}>
                        {message?.is_owner ? (
                          <ItemChatClient data={message} />
                        ) : (
                          <ItemChat
                            msg={message}
                            loveLvSettings={loveLvSettings}
                            character={character}
                            isScrollOpenTalk={() => setScroll(false)}
                            handleUpdateMessage={handleUpdateMessage}
                            indexMes={i}
                            handleOpenGift={handleOpenGift}
                            changeBgImage={changeBgImage}
                            channelInfo={channelInfo}
                            hasReadOnce={hasReadOnce}
                            setHasReadOnce={setHasReadOnce}
                          />
                        )}
                        <br />
                      </div>
                    ))}
                  </div>
                  <InputStoryTalk
                    setCheckClickIconBg={() => {}}
                    setIsClickIconBg={() => {}}
                    setCheckClickIconSetting={() => {}}
                    senderId={user?.id}
                    conversationId={conversationId}
                    handleNewMessages={(msg, checkStatus) => handleNewMessages(msg, checkStatus)}
                    setSizeInput={setSizeInput}
                    characterId={Number(characterId)}
                    loveLvSettings={loveLvSettings}
                    character={character}
                    setFiles={setFiles}
                    files={files}
                    setFileVideo={setFileVideo}
                    fileVideo={fileVideo}
                    setIsMultiLoveModalOpen={setIsMultiLoveModalOpen}
                    setMultiLevel={setMultiLevel}
                    channelInfo={channelInfo}
                  />
                </div>
              </div>
              <ModalGift
                isOpen={isOpenGift}
                onClose={() => setIsOpenGift(false)}
                present={present}
              />

              {/* Tips modal */}
              <TipsModal type="realtalk" isDetail />
            </div>
          </Container>
        </>
      )}
    </MainLayout>
  )
}

const Container = styled.div.attrs({
  className:
    'sm:w-desktop-width w-screen h-screen mx-auto relative font-Inter overflow-hidden bg-no-repeat bg-left-top bg-cover'
})``

const WrapperChatBox = styled.div.attrs({
  className: 'overflow-y-auto overflow-x-hidden hidden-scroll'
})`
  height: 100dvh;
  padding-bottom: 64px;
  position: relative;
  padding-top: 282px;
`

export default StoryTalkDetail
